import React, { useEffect, useState } from "react";
import Auth from "../../Auth";
import { ChangelogBtnWrapper } from "./styles";
import { Button } from "../Button";
import { loadFeaturebaseSdk } from "./loadFeaturebaseSdk";

export default function FeaturebaseChangelog() {
  const [token, setToken] = useState(null);
  const [sdkReady, setSdkReady] = useState(false);
  const [hasUnviewed, setHasUnviewed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const [data] = await Promise.all([Auth.fetchWithIdToken("/api/featurebase/sso?json=true"), loadFeaturebaseSdk()]);
        if (cancelled) return;
        setToken(data.token);
        setSdkReady(true);
      } catch (error) {
        console.error("Failed to prepare Featurebase changelog", error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!token || !sdkReady) return;

    let cancelled = false;

    const theme = document.body.dataset.themeType === "dark" ? "dark" : "light";
    const options = {
      jwtToken: token,
      organization: "sudowrite",
      theme, // Choose between dark or light theme
      locale: "en", // Change the language, view all available languages from https://help.featurebase.app/en/articles/8879098-using-featurebase-in-my-language
      fullscreenPopup: true, // true: the widget will automatically open as a fullscreen popup on the page load when there are new updates.
    };

    window.Featurebase("initialize_changelog_widget", options, (_error, data) => {
      if (cancelled) return;

      if (data?.action === "unreadChangelogsCountChanged") {
        setHasUnviewed((data.unreadCount ?? 0) > 0);
        return;
      }

      const count = window.Featurebase("unviewed_changelog_count");
      if (typeof count === "number") {
        setHasUnviewed(count !== 0);
      }
    });

    const count = window.Featurebase("unviewed_changelog_count");
    if (!cancelled && typeof count === "number") {
      setHasUnviewed(count !== 0);
    }

    return () => {
      cancelled = true;
    };
  }, [token, sdkReady]);

  if (!token || !sdkReady || !hasUnviewed) {
    return null;
  }

  const buttonProps = {
    "data-featurebase-changelog": true,
  };

  return (
    <ChangelogBtnWrapper>
      <Button
        tertiaryGrey
        className="changelog use-component-styles"
        {...buttonProps}
      >
        What's new
        <span id="fb-update-badge"></span>
      </Button>
    </ChangelogBtnWrapper>
  );
}

export const FeaturebaseSignin = () => {
  const [token, setToken] = useState(null);

  useEffect(() => {
    (async () => {
      const data = await Auth.fetchWithIdToken("/api/featurebase/sso?json=true");
      setToken(data.token);
    })();
  }, []);

  useEffect(() => {
    if (token) {
      const urlParams = new URLSearchParams(window.location.search);
      const returnTo = urlParams.get("return_to") || "https://sudowrite.featurebase.app/";
      window.location.href = `https://sudowrite.featurebase.app/api/v1/auth/access/jwt?jwt=${token}&return_to=${encodeURIComponent(returnTo)}`;
    }
  }, [token]);

  return null;
};
